<template>
  <div class="relative">
    <div
      class="vx-navbar-wrapper navbar-full p-0"
      :style="{
        background: isDark ? '#121212' : '#FAF6F1',
        padding: 0,
        zIndex: 49000,
      }"
    >
      <vs-navbar
        class="navbar-custom navbar-skelton"
        style="margin: 0 !important; padding: 8px 16px"
        :class="navbarClasses"
        :style="navbarStyle"
        :color="navbarColor"
        type="border"
      >
        <!-- Left: Logo + Title -->
        <div class="flex items-center">
          <img
            src="/logo.png"
            alt="POK"
            style="
              width: 36px;
              height: 36px;
              border-radius: 50%;
              object-fit: cover;
            "
            class="mr-3 cursor-pointer"
            @click="goHome"
          />
          <div class="mr-8">
            <p
              :style="{
                color: isDark ? '#F5F5F5' : '#333',
                fontSize: '14px',
                fontWeight: 800,
                letterSpacing: '1px',
                lineHeight: 1.2,
              }"
            >
              PALACE OF KEBAP
            </p>
            <p :style="{ color: isDark ? '#999' : '#666', fontSize: '11px' }">
              Düsseldorf
            </p>
          </div>
        </div>

        <vs-spacer />

        <!-- Right: Cart + More + Profile -->
        <div class="flex items-center">
          <div class="nav-cart-btn mr-3">
            <feather-icon
              icon="ShoppingBagIcon"
              svgClasses="w-5 h-5"
              style="color: var(--pok-text)"
            />
            <span v-if="cartLength > 0" class="nav-cart-badge">{{
              cartLength
            }}</span>
          </div>

          <div class="nav-cart-btn mr-3 cursor-pointer" @click="toggleTheme">
            <feather-icon
              :icon="isDark ? 'SunIcon' : 'MoonIcon'"
              svgClasses="w-5 h-5"
              style="color: var(--pok-text)"
            />
          </div>

          <vs-dropdown vs-trigger-click class="mr-3">
            <div class="nav-cart-btn cursor-pointer">
              <feather-icon
                icon="MoreHorizontalIcon"
                svgClasses="w-5 h-5"
                style="color: var(--pok-text)"
              />
            </div>
            <vs-dropdown-menu style="min-width: 180px">
              <vs-dropdown-item @click="$router.push('/faq').catch(() => {})"
                ><div class="flex items-center py-1">
                  <feather-icon
                    icon="HelpCircleIcon"
                    svgClasses="w-4 h-4 mr-3"
                  /><span>FAQ</span>
                </div></vs-dropdown-item
              >
              <vs-dropdown-item
                @click="$router.push('/kontakt').catch(() => {})"
                ><div class="flex items-center py-1">
                  <feather-icon
                    icon="MailIcon"
                    svgClasses="w-4 h-4 mr-3"
                  /><span>Kontakt</span>
                </div></vs-dropdown-item
              >
              <vs-dropdown-item divider @click="popupImprint = true"
                ><div class="flex items-center py-1">
                  <feather-icon
                    icon="FileTextIcon"
                    svgClasses="w-4 h-4 mr-3"
                  /><span>Impressum</span>
                </div></vs-dropdown-item
              >
              <vs-dropdown-item @click="popupPrivacy = true"
                ><div class="flex items-center py-1">
                  <feather-icon
                    icon="ShieldIcon"
                    svgClasses="w-4 h-4 mr-3"
                  /><span>Datenschutz</span>
                </div></vs-dropdown-item
              >
              <vs-dropdown-item @click="popupTerms = true"
                ><div class="flex items-center py-1">
                  <feather-icon
                    icon="BookOpenIcon"
                    svgClasses="w-4 h-4 mr-3"
                  /><span>AGBs</span>
                </div></vs-dropdown-item
              >
              <vs-dropdown-item @click="popupIngredients = true"
                ><div class="flex items-center py-1">
                  <feather-icon
                    icon="InfoIcon"
                    svgClasses="w-4 h-4 mr-3"
                  /><span>Zutaten & Zusatzstoffe</span>
                </div></vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>

          <profile-drop-down />
        </div>

        <vs-popup fullscreen title="Impressum" :active.sync="popupImprint"
          ><imprint
        /></vs-popup>
        <vs-popup
          fullscreen
          title="Datenschutzbestimmungen"
          :active.sync="popupPrivacy"
          ><privacy-statement
        /></vs-popup>
        <vs-popup
          fullscreen
          title="Allgemeine Geschäftsbedingungen"
          :active.sync="popupTerms"
          ><terms-and-conditions
        /></vs-popup>
        <vs-popup
          fullscreen
          title="Infos zu Zutaten"
          :active.sync="popupIngredients"
          ><ingredients
        /></vs-popup>
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileDropDown from "./components/ProfileDropDown.vue";

export default {
  name: "the-navbar-horizontal",
  props: {
    logo: { type: String },
    navbarType: { type: String, required: true },
  },
  components: { ProfileDropDown },
  data() {
    return {
      popupImprint: false,
      popupPrivacy: false,
      popupTerms: false,
      popupIngredients: false,
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
    isDark() {
      return this.$store.state.theme === "dark";
    },
    cartLength() {
      return this.$store.getters["shop/getCartLength"] || 0;
    },
    navbarColor() {
      return this.isDark ? "#121212" : "#FAF6F1";
    },
    navbarStyle() {
      return this.navbarType === "static"
        ? { transition: "all .25s ease-in-out" }
        : {};
    },
    navbarClasses() {
      return this.scrollY > 5 && this.navbarType === "static"
        ? null
        : "d-theme-dark-light-bg shadow-none";
    },
    scrollY() {
      return this.$store.state.scrollY;
    },
  },
  methods: {
    goHome() {
      window.location.href = "/";
    },
    toggleTheme() {
      var newTheme = this.$store.state.theme === "dark" ? "light" : "dark";
      this.$store.commit("UPDATE_THEME", newTheme);
      localStorage.setItem("theme", newTheme);
    },
  },
};
</script>

<style scoped>
.nav-link {
  color: #999;
  margin-right: 24px;
  font-size: 14px;
  font-weight: 500;
  transition: color 0.2s;
}
.nav-link:hover {
  color: var(--pok-text);
}
.router-link-active .nav-link {
  color: #c41e2a;
  font-weight: 600;
}
.nav-cart-btn {
  position: relative;
  padding: 8px;
  background: var(--pok-card);
  border-radius: 12px;
  border: 1px solid var(--pok-border);
  cursor: pointer;
  transition: border-color 0.2s;
}
.nav-cart-btn:hover {
  border-color: #666;
}
.nav-cart-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  background: #c41e2a;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
